import { BrowserStorage } from '@estee/elc-universal-utils';
import { VTO_MATCHES_COOKIE_NAME } from '../constants/Vto';

export const getVtoMatchCookie = () => {
    return BrowserStorage.getItem(VTO_MATCHES_COOKIE_NAME);
};
